<a *ngIf="data$ | async as data" [href]="data.url | sdSafeUrl" [attr.target]="getTarget(data)">
  <ng-container *ngIf="!!data.media; else link">
    <span
      type="button"
      class="chat-link"
      placement="left"
      [ngbTooltip]="data.tooltipText"
      tooltipClass="custom-tooltip"
      [attr.data-analytics]="dataAnalyticsAttribute$ | async"
    >
      <cx-media [container]="data.media"></cx-media>
      <span class="tooltip-text">{{ data.tooltipText }}</span>
    </span>
  </ng-container>
  <ng-template #link>{{ data.linkName }}</ng-template>
</a>
